import { IonImg, IonLabel } from "@ionic/react";
import React, { useEffect } from "react";

const ScreenBanner: React.FC = (props: any) => {
  return (
    <div className="nodata_img_parent">
      <IonImg src="/images/nodata_icon.svg" className="nodata_img" />
      <IonLabel className="no_data_text">
        Did you know ? Periodic maintenance can improve your brakes efficiency by 30%
      </IonLabel>
    </div>
  );
};

export default ScreenBanner;
